module.exports = __webpack_public_path__ + "static/media/logo-big.e4d692bc.svg";